import styled from 'styled-components';

import { spacing, colors } from '../../../../styles/theme';

import ImgOnbordingUp from '../../../../assets/icons/onboarding-background-up.svg';
import ImgOnbordingDown from '../../../../assets/icons/onboarding-background-down.svg';

export const OnboardingContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  background-color: ${colors('primary.base')};
  padding: ${spacing('10')} 0;
  background-image: url(${ImgOnbordingUp}), url(${ImgOnbordingDown});
  background-repeat: no-repeat;
  background-position: top left, bottom;
  background-size: auto, 100%;
`;

export const OnboardingLogin = styled.div`
  margin: auto;
  width: 470px;
`;

export const OnboardingTitle = styled.h1`
  font-size: 40px;
  color: ${colors('white.base')};
  letter-spacing: -0.006em;
  margin-bottom: ${spacing('2')};
  line-height: 130%;
`;

export const Highlight = styled.strong`
  font-weight: 700;
  color: white;
`;
